import React, { useEffect, useState } from 'react'
import { useMutation, useQuery } from '@apollo/client'
import { useLoading } from '../../../../LoadingOverlay/LoadingOverlayContext'
import LayoutTable from '../../../Global/LayoutTable'
import ContentHeader from '../../../Layout/ContentHeader'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import StatusOrderingModal from './components/StatusOrdering/StatusOrderingModal'
import {
  DELETE_STATUS,
  GET_ALL_STATUS,
  SAVE_ORDER_STATUS,
} from '../../../../graphql/Catalog/Status/status'

export const categorModule = 'water_truck_request'
export const backPage = '/catalog/status'
const idModal = 'modalOrder'

export const Status = () => {
  const { showLoading, hideLoading } = useLoading()

  //STATES
  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [total, setTotal] = useState(0)
  const [dataToTable, setDataToTable] = useState([])
  const [modalOrden, setModalOrden] = useState(false)
  const [modalConfig, setModalConfig] = useState({
    title: '',
    type: null,
  })

  //QUERIES
  const { loading, error, data, refetch } = useQuery(GET_ALL_STATUS, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
  })

  //MUTATIONS
  const [saveOrder] = useMutation(SAVE_ORDER_STATUS)

  //FUNCTIONS
  const handleShowModal = async ({ item }) => {
    setModalConfig({
      title: `Reordena los estatus de "${item.type}"`,
      type: item.type,
    })
    setModalOrden(true)
  }

  const handleOrder = async ({ items }) => {
    const itemsOrder = items.map((item, index) => ({
      id: item.id,
      order: index + 1,
    }))

    showLoading()

    try {
      await saveOrder({ variables: { input: itemsOrder } })
      await refetch()
    } catch (error) {
      toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  //EFFECTS
  useEffect(() => {
    if (!loading) {
      if (error)
        toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data.getAllCatalogStatus.rows.map((item) => {
        const respData = {
          id: item.id,
          Tipo: item.type,
          Nombre: item.name,
          Descripcion: item.description ? item.description : '',
          '%Progreso': item.progress ? item.progress + '%' : '',
          Color: item.color && (
            <div
              className="rounded"
              style={{
                backgroundColor: `${item.color}`,
                width: '65px',
                height: '20px',
              }}
            ></div>
          ),
          Orden: item.order ? item.order : '',
          Ordenar: (
            <button
              className="btn btn-sm btn-migrates"
              title="Ordenar estatus de este tipo"
              data-toggle="modal"
              data-target={`#${idModal}`}
              onClick={() => handleShowModal({ item })}
            >
              <i className="fas fa-retweet" />
            </button>
          ),
        }
        return list.push(respData)
      })
      setDataToTable(list)
      setTotal(data.getAllCatalogStatus.count)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, error, data])

  return (
    <>
      <ContentHeader title="Estatus" breadcrumb="" windowTitle="Estatus" />
      <LayoutTable
        data={dataToTable}
        title="Lista de estatus"
        gql={DELETE_STATUS}
        requery={GET_ALL_STATUS}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por nombre o tipo"
        hideId
        exportImportButton={false}
      />

      {modalOrden && (
        <StatusOrderingModal
          idModal={idModal}
          modal={modalOrden}
          setModal={setModalOrden}
          config={modalConfig}
          handleOrder={handleOrder}
        />
      )}
    </>
  )
}

export default Status
